export enum CompanyMBMColors {
  accentColor = '#E40046',
  secondaryColor = '#2C2C2C',
}

export enum CompanyCdekColors {
  accentColor = '#1DB248',
  secondaryColor = '#1B3339',
}

export enum CompanyJTIColors {
  accentColor = '#364ABA',
  secondaryColor = '#1BC27D',
}
